import getImageLink from './getImageLink'


export {
  getImageLink,
}
